import React, { useState, useEffect } from 'react';
import type { ReactElement } from 'react';
import { DynamoDB } from 'aws-sdk';
import { ActiveChannels } from '../common/channelsEnum';
import PlanPage from './PlanPage';
import {
  EnvironmentSettingsItem,
  UsageItem
} from '../../api/environments/interface';
import { getEnvironmentSettings } from '../../api/environments/api';
import { useParams } from 'react-router-dom';
import { setAWSCreds } from '../../utils/accessToken';

const PlanContainer = (): ReactElement => {
  const { accountId } = useParams<{ accountId: string }>();
  const [envSettingsItem, setEnvSettingsItem] =
    useState<EnvironmentSettingsItem>();
  const [usageItems, setUsageItems] = useState<UsageItem[]>();

  useEffect(() => {
    setAWSCreds().then(() => {
      getEnvironmentSettings(accountId).then((res) => {
        setEnvSettingsItem(res);
      });
      getUsageRecordsByEnvId(accountId).then((res) => {
        if (res.Responses) {
          setUsageItems(res.Responses['usageDb3'] as UsageItem[]);
        } else {
          setUsageItems([]);
        }
      });
    });
  }, [accountId]);

  return <PlanPage envSettingsItem={envSettingsItem} usageItems={usageItems} />;
};

const getUsageRecordsByEnvId = (envId: string) => {
  const ddb = new DynamoDB.DocumentClient();

  const secondaryKeys: string[] = [];
  const date = new Date();
  let currentMonth = date.getMonth() + 1;
  let currentYear = date.getFullYear();

  for (let index = 0; index < 12; index++) {
    if (currentMonth === 0) {
      currentMonth = 12;
      date.setFullYear(currentYear - 1);
      currentYear = date.getFullYear();
    }
    secondaryKeys.push(`${currentYear}${currentMonth}`);
    currentMonth--;
  }

  const primaryKeys = Object.values(ActiveChannels).map((c) => {
    return `${envId}:${c}`;
  });

  const keysToGet: { envIdChannel: string; yearMonth: string }[] = [];
  primaryKeys.map((p) =>
    secondaryKeys.map((s) => {
      return keysToGet.push({
        envIdChannel: p,
        yearMonth: s
      });
    })
  );

  return ddb
    .batchGet({
      RequestItems: {
        usageDb3: {
          Keys: keysToGet
        }
      }
    })
    .promise();
};

export default PlanContainer;
